export default "__VITE_ASSET__DlbOgQqG__"